import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gnd5y3vhd: FaireProductEntity = {
  token: "p_6gnd5y3vhd",
  type: "product",
  name: "TONI",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/ba9cd19a5f7d95afa89d518363b55bbdd050435f621a31a7490e84f9a1fa4974.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e01c80c7e55a7ff3827dd666054f0e56a47d978bd6e1adb7b05eed430683366f.jpeg",
    "https://cdn.faire.com/fastly/fdc36fa2d45c19bb862599b61da750c1cfffa1d2088939b05b9122afdb45e7c7.png"
  ],
  priceDollars: 10.05,
  description: "Chocolate Forward, Sticky Sweet\n\nNamed for Toni Morrison. An unapologetically chocolate coffee with a body you can feel.\n\nTasting Notes: Dark chocolate, hazelnut, plum\nOrigin: Rotating origin (current lot: Honduras, 1500m)\nProcess: Washed\nRoast Level: Medium-Dark\nRecommended Brew: Drip, pour-over, French press, or espresso with milk\n\nA chocolaty sweetness shines from start to finish, with hazelnut filling out the middle and a soft plum note adding complexity. Toni carries a big, sticky body that lingers between sips. Named for Toni Morrison, a favorite of the team, who shaped not just Black literature but the picture that comes to mind when people think of Black culture. Built for the cup that gets passed across the table.\n\nWhole bean or ground, roasted to order in Atlanta. Available in 310 g, 2 lb, and 5 lb.\n",
  tags: [],
  msrpDollars: 16.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:37.148Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
